import React from "react";
import PropTypes from "prop-types";
import * as S from "./styles";

export const Button = (props) => <S.Button {...props}>{props.label}</S.Button>;

Button.propTypes = {
  props: PropTypes.object,
};
